import { render } from "./VersionHistory.vue?vue&type=template&id=2beb8f2e&scoped=true"
import script from "./VersionHistory.vue?vue&type=script&lang=js"
export * from "./VersionHistory.vue?vue&type=script&lang=js"

import "./VersionHistory.vue?vue&type=style&index=0&id=2beb8f2e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2beb8f2e"]])

export default __exports__